import { createSlice } from '@reduxjs/toolkit';
import { IBoardItem, IBoardSubType, ICWInitialValues } from 'store/connectwise/types';
import {
  ThunkGetConnectwiseAgreements,
  ThunkGetConnectwiseBoardStatuses,
  ThunkGetConnectwiseBoardTypes,
  ThunkGetConnectwiseCompanies,
  ThunkGetConnectwiseContacts,
  ThunkGetConnectwisePriorities,
  ThunkGetConnectwiseServiceBoards,
  ThunkGetConnectwiseSites,
  ThunkGetConnectwiseSources,
} from 'store/connectwise/thunks';
import { IAutocomplete } from 'services/connectwise/types';

const initialState: ICWInitialValues = {
  agreements: [],
  boardItems: [],
  boardStatuses: [],
  boardSubTypes: [],
  boardTypes: [],
  companies: [],
  contacts: [],
  priorities: [],
  serviceBoards: [],
  sites: [],
  sources: [],
};

const connectwiseSlice = createSlice({
  name: 'connectwise',
  reducers: {},
  initialState,
  extraReducers: builder => {
    builder.addCase(ThunkGetConnectwiseAgreements.fulfilled, (state, action) => {
      state.agreements = action.payload.map(i => ({ value: String(i.value), label: i.label }));
    });

    builder.addCase(ThunkGetConnectwiseBoardStatuses.fulfilled, (state, action) => {
      state.boardStatuses = action.payload.map(i => ({ value: String(i.id), label: i.name }));
    });

    builder.addCase(ThunkGetConnectwiseBoardTypes.fulfilled, (state, action) => {
      const types: IAutocomplete[] = [];
      const subTypes: IBoardSubType[] = [];
      const items: IBoardItem[] = [];

      action.payload.forEach(type => {
        types.push({ value: String(type.id), label: type.name });

        type.boardSubTypes.forEach(subType => {
          subTypes.push({
            value: String(subType.id),
            label: subType.name,
            parentIds: subType.typeAssociationIds,
          });
          items.push(
            ...subType.items.map(i => ({
              value: String(i.id),
              label: i.name,
              parentIds: [subType.id],
            })),
          );
        });
      });

      state.boardTypes = types;
      state.boardSubTypes = subTypes;
      state.boardItems = items;
    });

    builder.addCase(ThunkGetConnectwiseCompanies.fulfilled, (state, action) => {
      state.companies = action.payload.map(i => ({ value: String(i.value), label: i.label }));
    });

    builder.addCase(ThunkGetConnectwiseContacts.fulfilled, (state, action) => {
      state.contacts = action.payload.map(i => ({ value: String(i.value), label: i.label }));
    });

    builder.addCase(ThunkGetConnectwisePriorities.fulfilled, (state, action) => {
      state.priorities = action.payload.map(i => ({ value: String(i.value), label: i.label }));
    });

    builder.addCase(ThunkGetConnectwiseServiceBoards.fulfilled, (state, action) => {
      state.serviceBoards = action.payload.map(i => ({ value: String(i.id), label: i.name }));
    });

    builder.addCase(ThunkGetConnectwiseSites.fulfilled, (state, action) => {
      state.sites = action.payload.map(i => ({ value: String(i.value), label: i.label }));
    });

    builder.addCase(ThunkGetConnectwiseSources.fulfilled, (state, action) => {
      state.sources = action.payload.map(i => ({ value: String(i.id), label: i.name }));
    });
  },
});

export default connectwiseSlice.reducer;
